import { useState } from "react";
import { useAccount, useConnect, useDisconnect } from "wagmi";
import WalletModal from "@/components/WalletModal/Modal";
import DisConnectModal from "@/components/DisConnectModal/Modal";
import PhoneImg from '@/assets/svg/phone.svg'
import ArbImg from '@/assets/svg/arb.svg'
import ExitSvg from '@/assets/svg/exit.svg'
import { ReactSVG } from 'react-svg'
import { masacAddress } from '@/utils/index'
import styled from "styled-components";
import {chainId} from "../../../utils/abi";


export default function Profile() {
  const { address, connector, isConnected } = useAccount();
  const { connect, connectors, error, isLoading, pendingConnector } =
    useConnect({
      chainId,
    });
  const { disconnect } = useDisconnect();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);

  if (isConnected) {
    return (
      <div>        
        <DisConnectModal handleClose={() => setIsOpen2(false)} isOpen={isOpen2}/>         
        <Btns>
          <NetWorkBtn>
              <span className="network">Arbitrum</span>
          </NetWorkBtn>
          <ConnectBtn onClick={() => setIsOpen2(true)}>
              <span className="btn-text">{masacAddress(address)}</span>
              <ReactSVG
               src={ExitSvg}
               className="exit-svg"
               beforeInjection={(svg) => {                
                svg.setAttribute('style', 'display: flex')
              }}
               />
            </ConnectBtn>
        </Btns>
      </div>
    );
  }

  return (
    <>    
      <ConnectBtn2 onClick={() => setIsOpen(true)}>
        <span className="btn-text">Connect</span>
      </ConnectBtn2>
      <WalletModal handleClose={() => setIsOpen(false)} isOpen={isOpen} />      
    </>
  );
}

const Btns = styled.div`
  display: flex;  
  color: #32DE86;
  font-weight: 600;
  font-size: 16px;
`
const NetWorkBtn = styled.div`
  display: flex;
  align-items: center;
  padding: 0 11px 0 17px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  height: 40px;
  line-height: 40px;  
  margin-right: 8px;  
  cursor: pointer;  
`

const ConnectBtn = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px 0 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  height: 40px;
  line-height: 40px;  
  cursor: pointer;    
  .exit-svg{
    padding-left:16px;
  }
  .btn-text{
    color: #32DE86;
    font-weight: 600;
    font-size: 16px;
  }
`
const ConnectBtn2 = styled.div`
  width: 130px;
  height: 42px;
  line-height: 42px;  
  background: #32DE86;  
  text-align: center;
  cursor: pointer;
  border-radius:8px;
  .btn-text{
    color: #fff;
    font-weight: 600;
    font-size: 16px;  
  }
`
